export const aodaRoutes = [
  {
    path: '/aoda',
    name: 'aoda',
    component: () => import(/* webpackChunkName: "aoda" */ './Aoda.vue')
  }
];
